import { Container, Sprite } from 'pixi.js'
import { graphic } from "../Graphic";
import { graphicEvents, ON_CHANGE_ZOOM } from "../GraphicEvents";
import { Shape } from "./Shape";

export class Button {

    /**
     * Button constructor
     * @param imageUrl
     * @param x
     * @param y
     * @param radius
     * @param parent
     */
    constructor({ resource, x, y, scale, radius, parent }) {
        this.container = new Container();
        this.parent = parent;
        this.radius = radius;
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.resource = resource;

        this.container.interactive = true;
        this.update = this.update.bind(this);
    }

    update() {
        if (!this.resource) return;
        this.container.height = this.radius / graphic.zoom;
        this.container.width = this.radius / graphic.zoom;
        this.container.y = this.y / graphic.zoom;
        this.container.x = this.x;

        this.sprite.x = -(this.sprite.width / 2);
        this.sprite.y = -(this.sprite.height / 2);

        this.circle.radius = (this.radius / 2) * graphic.zoom;
        this.circle.dirty++;
        this.circle.clearDirty++;
    }

    draw() {
        if (!this.resource) return;
        this.sprite = new Sprite(this.resource.texture);

        this.sprite.scale.x = this.scale;
        this.sprite.scale.y = this.scale;

        this.circle = Shape.createCircle(0, 0, 20, [0xFFFFFF, 1], [1, 0x777777]);

        this.container.addChild(this.circle);
        this.container.addChild(this.sprite);
        this.parent.addChild(this.container);
        graphicEvents.on(ON_CHANGE_ZOOM, this.update);

        this.update();
    }

    destroy() {
        if (!this.resource) return;
        this.parent.removeChild(this.container);
        graphicEvents.remove(ON_CHANGE_ZOOM, this.update);
    }
}